import { changePasswordStyles as styles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { css } from "styled-components";

styles.passwordGridContainer = {
    ...styles.passwordGridContainer,
    css: css`
        ${styles.passwordGridContainer?.css};
        margin: 0;
    `,
};
